/**
 * @see ~/lang
 * @usage
 * key: value
 */
export default {}
